import styled, { css } from 'styled-components';
import {
  COLOR_BLACK,
  COLOR_SPOTIFY_GREEN,
} from 'client/components/MarketingPagesShared/styles';
import { PODCAST_COLORS } from 'client/utils';

export const LoginSignupContainer = styled.div<{
  showHeroLoginSignUpForm?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${COLOR_BLACK};
  text-align: center;
  background: ${PODCAST_COLORS.WHITE.color};
  ${({ showHeroLoginSignUpForm }) =>
    showHeroLoginSignUpForm
      ? css`
          padding: 24px 2%;
          max-width: 475px;
          border-radius: 15px;
          margin: 20px 4% 20px 0;
        `
      : css`
          padding: 70px 20%;
          width: 100%;
        `}
  input:active,
  input:focus,
  select:active,
  select:focus {
    border-color: ${COLOR_SPOTIFY_GREEN};
  }
  button {
    color: ${COLOR_BLACK};
    &[type='submit'],
    &[type='submit']:focus,
    &[type='submit']:active:hover:focus {
      border-color: ${COLOR_SPOTIFY_GREEN};
      background: ${COLOR_SPOTIFY_GREEN};
    }
  }
  form {
    width: 100%;
    max-width: 372px;
    margin: 0 auto;
  }
  a {
    color: ${COLOR_BLACK};
    font-weight: bold;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  div[class*='styles__successButton'] {
    svg > circle {
      fill: ${COLOR_SPOTIFY_GREEN};
    }
  }
`;

export const LoginSignupHeading = styled.h2`
  margin: 0 0 8px;
  font-size: 1.875rem;
  line-height: 40px;
  letter-spacing: -0.008em;
`;

export const LoginSignUpOption = styled.p<{ isLogin?: boolean }>`
  margin: ${({ isLogin }) => (isLogin ? '20px 0' : '0 0 20px')};
  font-size: 0.875rem;
  line-height: 24px;

  /* stylelint-disable no-descending-specificity */
  a,
  a:focus,
  button {
    padding: 0;
    color: ${COLOR_BLACK};
    font-weight: bold;
  }
  /* stylelint-enable no-descending-specificity */
`;

export const LoginSignUpTerms = styled.div`
  font-size: 0.688rem;
  line-height: 16px;

  /* stylelint-disable no-descending-specificity */
  a,
  a:focus {
    color: ${COLOR_BLACK};
    font-weight: bold;
  }
  /* stylelint-enable no-descending-specificity */
`;
